export class Npsmeter {

    static trigger(callback) {
        let userInfo = JSON.parse(sessionStorage.getItem('ce-center-ce-user-info'));
        if (userInfo.name != null && decodeURIComponent(userInfo.name).indexOf('@300.cn') === -1) {
            callback(userInfo);
        }
    }

    /**
     * 首页埋点
     */
    static index() {
        this.trigger((userInfo) => {
            npsmeter({ key: '6964970d75d74dc3', user_id: userInfo.userId, user_name: userInfo.name });
            setTimeout(() => npsmeter.open("6964970d75d74dc3"), 5000);
        });
    }

    /**
     * 产品埋点
     */
    static product() {
        this.trigger((userInfo) => {
            npsmeter({ key: 'b3c458f51c4f3d7f', user_id: userInfo.userId, user_name: userInfo.name });
            setTimeout(() => npsmeter.open("b3c458f51c4f3d7f"), 5000);
        });
    }

    /**
     * 低代码内容
     */
    static lowCodeContent() {
        this.trigger((userInfo) => {
            npsmeter({ key: '335ceb50f80d73e9', user_id: userInfo.userId, user_name: userInfo.name });
            setTimeout(() => npsmeter.open("335ceb50f80d73e9"), 5000);
        })
    }

    /**
     * 访问统计埋点
     */
    static visitStatistics() {
        this.trigger((userInfo) => {
            npsmeter({ key: 'a03829389affcf09', user_id: userInfo.userId, user_name: userInfo.name });
            setTimeout(() => npsmeter.open("a03829389affcf09"), 5000);
        });
    }

}